module.exports = "/images/login-icon-clear.png?f86c79e50dead1a4d87b7c289e15c53f";